// 第二次改版 2025-5
// import { Modal, Image, message } from "antd";
// import { ExclamationCircleFilled } from "@ant-design/icons";
// import { BASE_URL } from "./config";
// import dayjs from "dayjs";

//  提取错误图片占位符为常量，避免重复定义
//  const ERROR_IMAGE_FALLBACK = "data:image/png;base64,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";

// /**
//  * 显示确认对话框
//  * @param {string|ReactNode} content - 对话框内容
//  * @returns {Promise<boolean>} 点击确定返回true，取消返回false
//  */
// const showConfirm = (content) => {
//   const { confirm } = Modal;
//   // 修复拼写错误 resolve -> resolve
//   return new Promise((resolve) => {
//     confirm({
//       title: '提示',
//       icon: <ExclamationCircleFilled />,
//       content,
//       okText: '确定',
//       cancelText: '取消',
//       onOk: () => resolve(true),
//       onCancel: () => resolve(false),
//     });
//   });
// };

// /**
//  * 检查用户是否登录
//  * @returns {boolean} 是否登录
//  */
// const isLogin = () => {
//   // 简化逻辑，直接返回存在性判断
//   return !!localStorage.getItem('crm_manage_account');
// };

// /**
//  * 获取当前登录用户信息
//  * @returns {Object} 用户信息对象
//  */
// const crmManageAccount = () => {
//   try {
//     const account = localStorage.getItem('crm_manage_account');
//     return account ? JSON.parse(account) : {
//       account: '',
//       role: null,
//       token: 0
//     };
//   } catch (error) {
//     // 增加错误捕获，避免JSON解析失败导致页面崩溃
//     console.error('解析用户信息失败:', error);
//     return { account: '', role: null, token: 0 };
//   }
// };

// /**
//  * 延迟刷新页面
//  * @param {number} s - 延迟时间(毫秒)，默认2000ms
//  */
// const reload = (s = 2000) => {
//   // 增加参数校验，确保延迟时间有效
//   if (typeof s !== 'number' || s < 0) {
//     console.warn('无效的延迟时间，使用默认值2000ms');
//     s = 2000;
//   }
//   setTimeout(() => {
//     window.location.reload();
//   }, s);
// };

// /**
//  * 渲染图片列表
//  * @param {string} img - 图片路径字符串(逗号分隔)
//  * @param {number} width - 图片宽度，默认100
//  * @returns {ReactNode} 图片组件或图片列表
//  */
// const renderImg = (img, width = 100) => {
//   // 统一错误图片渲染逻辑
//   const renderErrorImg = () => (
//     <Image
//       width={width}
//       src="error"
//       fallback={ERROR_IMAGE_FALLBACK}
//       alt="图片加载失败" // 增加alt属性，提升可访问性
//     />
//   );

//   if (!img) {
//     return renderErrorImg();
//   }

//   const arr = img.split(',').filter(item => item.trim()); // 过滤空字符串
//   if (arr.length === 0) {
//     return renderErrorImg();
//   }

//   // 为图片添加间距样式，提升视觉体验
//   return arr.map((item, index) => (
//     <Image
//       key={index}
//       src={`${BASE_URL}${item}`}
//       width={width}
//       fallback={ERROR_IMAGE_FALLBACK}
//       alt={`图片${index + 1}`}
//       style={{ marginRight: 8, marginBottom: 8 }}
//     />
//   ));
// };

// /**
//  * 禁用未来日期（包含今天之后的日期）
//  * @param {dayjs} current - 当前日期
//  * @returns {boolean} 是否禁用
//  */
// const disabledDate = (current) => {
//   return current && current > dayjs().endOf('day');
// };

// /**
//  * 审核日期禁用逻辑（与disabledDate一致，保持接口兼容）
//  * @param {dayjs} current - 当前日期
//  * @returns {boolean} 是否禁用
//  */
// const toExamineDate = disabledDate;

// /**
//  * 月份禁用逻辑（修复拼写错误）
//  * @param {dayjs} current - 当前日期
//  * @returns {boolean} 是否禁用
//  */
// const month = (current) => {
//   // 修复拼写错误 'da' -> 'day'
//   return current && current > dayjs().endOf('day');
// };

// /**
//  * 生成指定长度的日期列表（从end开始向前推算）
//  * @param {string|dayjs} end - 结束日期
//  * @param {number} len - 日期数量，默认7
//  * @returns {string[]} 格式化的日期数组(YYYY-MM-DD)
//  */
// const weekDays = (end, len = 7) => {
//   // 校验参数有效性
//   if (!end || !dayjs(end).isValid()) {
//     console.warn('无效的结束日期，使用当前日期');
//     end = dayjs();
//   }
//   if (typeof len !== 'number' || len < 1) {
//     console.warn('无效的日期长度，使用默认值7');
//     len = 7;
//   }

//   const days = [];
//   const endDate = dayjs(end);
//   for (let i = 0; i < len; i++) {
//     days.unshift(endDate.subtract(i, 'day').format('YYYY-MM-DD'));
//   }
//   return days;
// };

// /**
//  * 手机号脱敏处理
//  * @param {string} phone - 手机号
//  * @returns {string} 脱敏后的手机号
//  */
// const renderPhone = (phone) => {
//   // 增强校验，确保是字符串类型
//   if (typeof phone !== 'string' || phone.length !== 11) {
//     return phone;
//   }
//   // 使用正则表达式更简洁
//   return phone.replace(/^(\d{3})(\d{4})(\d{4})$/, '$1****$3');
// };



//   /**
//    * 格式化日期为 YYYY-MM-DD 格式
//    * @param {Date|string|number} date - 日期对象/时间戳/日期字符串
//    * @returns {string} 格式化后的日期字符串
//    */
//   export const formatDate = (date) => {
//     if (!date) return '';
//     const d = new Date(date);
//     // 处理无效日期
//     if (isNaN(d.getTime())) return '';
//     const year = d.getFullYear();
//     const month = String(d.getMonth() + 1).padStart(2, '0');
//     const day = String(d.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   };

//   /**
//    * 处理文件下载（支持 Excel/JSON 错误响应）
//    * @param {Response} response - fetch 响应对象
//    * @param {string} baseFilename - 基础文件名（如 "全量进件数据表.xlsx"）
//    * @param {Array} [dateRange] - 日期范围数组 [startDate, endDate]（可选，用于文件名前缀）
//    * @returns {Promise<void>}
//    */
//   export const handleFileDownload = async (response, baseFilename, dateRange = []) => {
//     const contentType = response.headers.get('content-type') || '';

//     try {
//       // 1. 处理后端返回的 JSON 格式错误（如参数错误、无数据等）
//       if (contentType.includes('application/json')) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || '下载失败，请重试');
//       }

//       // 2. 验证响应是否为 blob 类型（避免非文件响应）
//       if (!contentType.includes('spreadsheetml.sheet') && !contentType.includes('octet-stream')) {
//         throw new Error('响应不是有效的文件类型');
//       }

//       // 3. 解析 blob 数据
//       const blob = await response.blob();
//       const currentDate = formatDate(new Date());

//       // 4. 处理文件名前缀（日期范围优先，无则用当前日期）
//       let datePrefix = '';
//       if (dateRange.length === 2 && dateRange[0] && dateRange[1]) {
//         const startDate = formatDate(dateRange[0]);
//         const endDate = formatDate(dateRange[1]);
//         datePrefix = `${startDate} - ${endDate} `;
//       } else {
//         datePrefix = `${currentDate} `;
//       }

//       // 5. 从响应头获取文件名（优先使用后端返回的文件名）
//       let filename = `${datePrefix}${baseFilename}`;
//       const contentDisposition = response.headers.get('content-disposition');
//       if (contentDisposition) {
//         // 匹配 RFC 5987 标准（filename*=UTF-8''xxx）
//         const utf8Match = contentDisposition.match(/filename\*=UTF-8''([\w%-]+(?:\.[\w]+)?)/i);
//         if (utf8Match) {
//           filename = `${datePrefix}${decodeURIComponent(utf8Match[1])}`;
//         } else {
//           // 匹配传统格式（filename="xxx" 或 filename=xxx）
//           const match = contentDisposition.match(/filename=(["']?)(.*?)\1/i);
//           if (match && match[2]) {
//             filename = `${datePrefix}${decodeURIComponent(match[2])}`;
//           }
//         }
//       }

//       // 6. 触发浏览器下载
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = filename; // 文件名包含日期前缀
//       document.body.appendChild(a);
//       a.click();

//       // 7. 清理资源（避免内存泄漏）
//       setTimeout(() => {
//         document.body.removeChild(a);
//         window.URL.revokeObjectURL(url);
//       }, 100);

//       message.success('下载成功');
//     } catch (error) {
//       message.error(error.message || '下载失败，请重试');
//       console.error('文件下载失败详情：', error);
//       throw error; // 可选：抛出错误供调用方二次处理
//     }
//   };




// export {
//   showConfirm,
//   isLogin,
//   reload,
//   crmManageAccount,
//   renderImg,
//   disabledDate,
//   toExamineDate,
//   month,
//   weekDays,
//   renderPhone,
//   formatDate,
//   handleFileDownload
// };








// 第三次改版 2025-11-27
import { Modal, Image, message } from "antd"; // 新增导入 message
import { ExclamationCircleFilled } from "@ant-design/icons";
import { BASE_URL } from "./config";
import dayjs from "dayjs";

// 提取错误图片占位符为常量，避免重复定义
const ERROR_IMAGE_FALLBACK = "data:image/png;base64,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";

/**
 * 显示确认对话框
 * @param {string|ReactNode} content - 对话框内容
 * @returns {Promise<boolean>} 点击确定返回true，取消返回false
 */
const showConfirm = (content) => {
  const { confirm } = Modal;
  return new Promise((resolve) => {
    confirm({
      title: '提示',
      icon: <ExclamationCircleFilled />,
      content,
      okText: '确定',
      cancelText: '取消',
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
};

/**
 * 检查用户是否登录
 * @returns {boolean} 是否登录
 */
const isLogin = () => {
  return !!localStorage.getItem('crm_manage_account');
};

/**
 * 获取当前登录用户信息
 * @returns {Object} 用户信息对象
 */
const crmManageAccount = () => {
  try {
    const account = localStorage.getItem('crm_manage_account');
    return account ? JSON.parse(account) : {
      account: '',
      role: null,
      token: 0
    };
  } catch (error) {
    console.error('解析用户信息失败:', error);
    return { account: '', role: null, token: 0 };
  }
};

/**
 * 延迟刷新页面
 * @param {number} s - 延迟时间(毫秒)，默认2000ms
 */
const reload = (s = 2000) => {
  if (typeof s !== 'number' || s < 0) {
    console.warn('无效的延迟时间，使用默认值2000ms');
    s = 2000;
  }
  setTimeout(() => {
    window.location.reload();
  }, s);
};

/**
 * 渲染图片列表
 * @param {string} img - 图片路径字符串(逗号分隔)
 * @param {number} width - 图片宽度，默认100
 * @returns {ReactNode} 图片组件或图片列表
 */
const renderImg = (img, width = 100) => {
  const renderErrorImg = () => (
    <Image
      width={width}
      src="error"
      fallback={ERROR_IMAGE_FALLBACK}
      alt="图片加载失败"
    />
  );

  if (!img) {
    return renderErrorImg();
  }

  const arr = img.split(',').filter(item => item.trim());
  if (arr.length === 0) {
    return renderErrorImg();
  }

  return arr.map((item, index) => (
    <Image
      key={index}
      src={`${BASE_URL}${item}`}
      width={width}
      fallback={ERROR_IMAGE_FALLBACK}
      alt={`图片${index + 1}`}
      style={{ marginRight: 8, marginBottom: 8 }}
    />
  ));
};

/**
 * 禁用未来日期（包含今天之后的日期）
 * @param {dayjs} current - 当前日期
 * @returns {boolean} 是否禁用
 */
const disabledDate = (current) => {
  return current && current > dayjs().endOf('day');
};

/**
 * 审核日期禁用逻辑（与disabledDate一致，保持接口兼容）
 * @param {dayjs} current - 当前日期
 * @returns {boolean} 是否禁用
 */
const toExamineDate = disabledDate;

/**
 * 月份禁用逻辑（修复拼写错误）
 * @param {dayjs} current - 当前日期
 * @returns {boolean} 是否禁用
 */
const month = (current) => {
  return current && current > dayjs().endOf('day');
};

/**
 * 生成指定长度的日期列表（从end开始向前推算）
 * @param {string|dayjs} end - 结束日期
 * @param {number} len - 日期数量，默认7
 * @returns {string[]} 格式化的日期数组(YYYY-MM-DD)
 */
const weekDays = (end, len = 7) => {
  if (!end || !dayjs(end).isValid()) {
    console.warn('无效的结束日期，使用当前日期');
    end = dayjs();
  }
  if (typeof len !== 'number' || len < 1) {
    console.warn('无效的日期长度，使用默认值7');
    len = 7;
  }

  const days = [];
  const endDate = dayjs(end);
  for (let i = 0; i < len; i++) {
    days.unshift(endDate.subtract(i, 'day').format('YYYY-MM-DD'));
  }
  return days;
};

/**
 * 手机号脱敏处理
 * @param {string} phone - 手机号
 * @returns {string} 脱敏后的手机号
 */
const renderPhone = (phone) => {
  if (!phone) return '-'
  if (typeof phone !== 'string' || phone.length !== 11) {
    return phone;
  }
  return phone.replace(/^(\d{3})(\d{4})(\d{4})$/, '$1****$3');
};

  /**
   * 身份证号脱敏：18位→前6后4，15位→前6后5，空值返回-
   * @param {string/number} idcard 身份证号（字符串/数字类型均可）
   * @returns {string} 脱敏后的身份证号
   */
  const renderIdCard = (idcard) => {
    if (!idcard) return '-'
    const idStr = String(idcard)
    // 匹配18位身份证（最常用）
    if (/^\d{18}$/.test(idStr)) {
      return idStr.replace(/^(\d{6})\d{8}(\d{4})$/, '$1********$2')
    }
    // 兼容15位老身份证
    if (/^\d{15}$/.test(idStr)) {
      return idStr.replace(/^(\d{6})\d{4}(\d{5})$/, '$1****$2')
    }
    // 非身份证格式，原样返回
    return idStr
  }

  /**
   * 格式化日期为 YYYY-MM-DD 格式
   * @param {Date|string|number} date - 日期对象/时间戳/日期字符串
   * @returns {string} 格式化后的日期字符串
   */
  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    // 处理无效日期
    if (isNaN(d.getTime())) return '';
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  /**
   * 处理文件下载（支持 Excel/JSON 错误响应）
   * @param {Response} response - fetch 响应对象
   * @param {string} baseFilename - 基础文件名（如 "全量进件数据表.xlsx"）
   * @param {Array} [dateRange] - 日期范围数组 [startDate, endDate]（可选，用于文件名前缀）
   * @returns {Promise<void>}
   */
  const handleFileDownload = async (response, baseFilename, dateRange = []) => {
    const contentType = response.headers.get('content-type') || '';
    try {
      // 1. 处理后端返回的 JSON 格式错误（如参数错误、无数据等）
      if (contentType.includes('application/json')) {
        const errorData = await response.json();
        throw new Error(errorData.message || '下载失败，请重试');
      }

      // 2. 验证响应是否为 blob 类型（避免非文件响应）
      if (!contentType.includes('spreadsheetml.sheet') && !contentType.includes('octet-stream')) {
        throw new Error('响应不是有效的文件类型');
      }

      // 3. 解析 blob 数据
      const blob = await response.blob();
      const currentDate = formatDate(new Date());

      // 4. 处理文件名前缀（日期范围优先，无则用当前日期）
      let datePrefix = '';
      if (dateRange.length === 2 && dateRange[0] && dateRange[1]) {
        const startDate = formatDate(dateRange[0]);
        const endDate = formatDate(dateRange[1]);
        datePrefix = `${startDate} - ${endDate} `;
      } else {
        datePrefix = `${currentDate} `;
      }

      // 5. 从响应头获取文件名（优先使用后端返回的文件名）
      let filename = `${datePrefix}${baseFilename}`;
      const contentDisposition = response.headers.get('content-disposition');
      if (contentDisposition) {
        // 匹配 RFC 5987 标准（filename*=UTF-8''xxx）
        const utf8Match = contentDisposition.match(/filename\*=UTF-8''([\w%-]+(?:\.[\w]+)?)/i);
        if (utf8Match) {
          filename = `${datePrefix}${decodeURIComponent(utf8Match[1])}`;
        } else {
          // 匹配传统格式（filename="xxx" 或 filename=xxx）
          const match = contentDisposition.match(/filename=(["']?)(.*?)\1/i);
          if (match && match[2]) {
            filename = `${datePrefix}${decodeURIComponent(match[2])}`;
          }
        }
      }
     
      // 6. 触发浏览器下载
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename; // 文件名包含日期前缀
      document.body.appendChild(a);
      a.click();

      // 7. 清理资源（避免内存泄漏）
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 100);

      message.success('下载成功');
    } catch (error) {
      message.error(error.message || '下载失败，请重试');
    }
  };


export {
  showConfirm,
  isLogin,
  reload,
  crmManageAccount,
  renderImg,
  disabledDate,
  toExamineDate,
  month,
  weekDays,
  renderPhone,
  renderIdCard,
  formatDate, // 新增导出
  handleFileDownload
};